import React from "react";
import { Button, Space } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { useIntl } from "react-intl";
import RestrictedComponent from "../../../components/util/RestrictedComponent";

const SelectionActions = (props) => {
  const { selectedRowKeys, onShowReplaceEmployee } = props;
  const intl = useIntl();

  return (
    <RestrictedComponent resource={"patients"} action={"editor"} comp={null}>
      <div style={{ padding: "10px 20px", height: "50px" }}>
        {selectedRowKeys && selectedRowKeys.length > 0 && (
          <Space>
            <Button
              onClick={() => onShowReplaceEmployee(selectedRowKeys)}
              icon={<CheckOutlined />}
            >
              {" " +
                intl.formatMessage({
                  id: "app.plan.replace_plan_employee",
                })}
            </Button>
          </Space>
        )}
      </div>
    </RestrictedComponent>
  );
};

export default SelectionActions;
